import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

/**
 * Hook to create a guided tour for the Discounts page
 * Uses Driver.js to highlight elements and show explanations
 */
export function useDiscountsTour() {
    const { t } = useTranslation();

    const startTour = useCallback(() => {
        const driverObj = driver({
            showProgress: true,
            animate: true,
            allowClose: true,
            stagePadding: 4,
            nextBtnText: t('tour.next'),
            prevBtnText: t('tour.back'),
            doneBtnText: t('tour.last'),
            progressText: '{{current}} / {{total}}',
            steps: [
                {
                    popover: {
                        title: t('tour.discounts.intro.title'),
                        description: t('tour.discounts.intro.description'),
                    },
                },
                {
                    element: '#fab-add-button',
                    popover: {
                        title: t('tour.discounts.addButton.title'),
                        description: t('tour.discounts.addButton.description'),
                        side: 'top',
                        align: 'end',
                    },
                },
                {
                    element: 'table tbody tr td:first-child a',
                    popover: {
                        title: t('tour.discounts.discountName.title'),
                        description: t(
                            'tour.discounts.discountName.description',
                        ),
                        side: 'bottom',
                        align: 'start',
                    },
                },
                {
                    element: 'input[type="text"]',
                    popover: {
                        title: t('tour.discounts.nameFilter.title'),
                        description: t('tour.discounts.nameFilter.description'),
                        side: 'bottom',
                        align: 'start',
                    },
                },
            ],
        });

        driverObj.drive();
    }, [t]);

    return { startTour };
}
